import { MessageCircle, Mail, Linkedin, Users } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

export default function CTA({ content }) {
  const waNumber = (content.whatsapp || "").replace(/[^0-9]/g, "");
  return (
    <section id="contact" data-testid="cta-section" className="relative bg-navy py-20 sm:py-28 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, #B9D0F2 1px, transparent 0)",
        backgroundSize: "36px 36px",
      }} />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <div className="flex justify-center"><Overline light>Get In Touch</Overline></div>
          <h2 className="mt-6 font-serif font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.1]" data-testid="cta-title">
            {content.cta_title}
          </h2>
          <p className="mt-5 text-base sm:text-lg font-sans text-white/65 leading-relaxed max-w-2xl mx-auto" data-testid="cta-subtitle">
            {content.cta_subtitle}
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={`https://wa.me/${waNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-contact-button"
              className="group inline-flex items-center gap-3 bg-cherry hover:bg-[#B81919] text-white font-medium px-8 py-4 rounded-full transition-colors duration-300 w-full sm:w-auto justify-center"
            >
              <MessageCircle className="h-5 w-5" />
              WhatsApp Us
            </a>
            <a
              href={`mailto:${content.email}`}
              data-testid="email-contact-button"
              className="inline-flex items-center gap-3 border border-white/30 hover:border-white/60 text-white font-medium px-8 py-4 rounded-full transition-colors duration-300 w-full sm:w-auto justify-center"
            >
              <Mail className="h-5 w-5" />
              {content.email}
            </a>
          </div>

          {(content.linkedin_url || content.whatsapp_group_url) && (
            <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-4">
              {content.linkedin_url && (
                <a
                  href={content.linkedin_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="linkedin-contact-button"
                  className="inline-flex items-center gap-3 border border-sky/30 hover:border-sky/60 text-sky font-medium px-8 py-3.5 rounded-full transition-colors duration-300 w-full sm:w-auto justify-center"
                >
                  <Linkedin className="h-4 w-4" />
                  Connect on LinkedIn
                </a>
              )}
              {content.whatsapp_group_url && (
                <a
                  href={content.whatsapp_group_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="whatsapp-group-button"
                  className="inline-flex items-center gap-3 border border-sky/30 hover:border-sky/60 text-sky font-medium px-8 py-3.5 rounded-full transition-colors duration-300 w-full sm:w-auto justify-center"
                >
                  <Users className="h-4 w-4" />
                  Join WhatsApp Community (SSH Updates)
                </a>
              )}
            </div>
          )}

          {content.whatsapp_group_url && (
            <p className="mt-4 text-xs font-sans text-white/40" data-testid="whatsapp-group-note">
              Workshop &amp; conference notifications for social science and humanities scholars.
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
